module.exports = __webpack_public_path__ + "static/media/trustedlogo.95947703.svg";